import { adminApi } from './admin-api';
import type { AdminFilters, AdminUser, AdminUserDetail, ApiResponse, PaginatedResponse } from '@/types/admin.types';

export const adminUsersService = {
  getAll: async (filters: AdminFilters = {}): Promise<PaginatedResponse<AdminUser>> => {
    const params = new URLSearchParams();
    if (filters.page) params.set('page', String(filters.page));
    if (filters.limit) params.set('limit', String(filters.limit));
    if (filters.search) params.set('search', filters.search);
    if (filters.sortBy) params.set('sortBy', filters.sortBy);
    if (filters.sortOrder) params.set('sortOrder', filters.sortOrder);
    const response = await adminApi.get(`/admin/users?${params.toString()}`);
    return response.data;
  },

  getById: async (uuid: string): Promise<ApiResponse<AdminUserDetail>> => {
    const response = await adminApi.get(`/admin/users/${uuid}`);
    return response.data;
  },

  toggleLock: async (uuid: string): Promise<{ message: string }> => {
    const response = await adminApi.post(`/admin/users/${uuid}/toggle-lock`);
    return response.data;
  },

  resetPassword: async (uuid: string): Promise<{ message: string }> => {
    const response = await adminApi.post(`/admin/users/${uuid}/reset-password`);
    return response.data;
  },

  impersonate: async (uuid: string): Promise<{ accessToken: string; expiresIn: number; user: any }> => {
    const response = await adminApi.post(`/admin/users/${uuid}/impersonate`);
    return response.data;
  },

  deleteUser: async (uuid: string): Promise<{ message: string }> => {
    const response = await adminApi.delete(`/admin/users/${uuid}`);
    return response.data;
  },

  updateRole: async (uuid: string, role: string): Promise<{ message: string }> => {
    const response = await adminApi.patch(`/admin/users/${uuid}/role`, { role });
    return response.data;
  },
};
